<template>
  <div>
    <v-card
      :height="height"
      dark
      :elevation="elevation"
      :shaped="shaped"
      :style="{ color: color, 'background-color': bgColor }"
      class="pb-4"
    >
      <v-card-title
        v-if="title"
        :style="{ color: color, 'background-color': bgColor }"
        >{{ title }}</v-card-title
      >
      <header>
        <slot name="header"></slot>
      </header>

      <slot name="content">
        <v-card-text
          v-if="text"
          :style="{ color: color, 'background-color': bgColor }"
        >
          {{ text }}
        </v-card-text>
      </slot>

      <footer>
        <slot name="footer"></slot>
      </footer>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: null,
    },
    text: {
      default: "",
    },
    color: {
      default: "white",
    },
    bgColor: {
      default: "black",
    },
    elevation: {
      default: 0,
    },
    shaped: {
      default: false,
    },
    height: {
      default: null,
    },
  },
};
</script>

<style></style>
